module.exports = __webpack_public_path__ + "static/img/image378-3.f655ed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/news/image378-3.png
// module id = YwGW
// module chunks = 31